/* istanbul ignore file */
import { pxToRem, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts, designSystemFontSizes, colors } = theme;

export const smallPill = css`
  padding: 0 ${pxToRem(4)} 0 ${pxToRem(5)};
  height: ${pxToRem(16)};
  width: ${pxToRem(35)};
  border-radius: ${pxToRem(spacing.xs)};
  background-color: ${colors.greySlate};
  color: ${colors.white};
  text-align: center;
  line-height: ${pxToRem(16)};
  font-size: ${pxToRem(designSystemFontSizes.BODY.XS.fontSize)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;
